import { getFn } from './api';

export interface BuildInfo {
  version: string;
  date: string;
}

const BUILDINFO_URL = '/buildinfo';

/**
 * Fetches server build info (version, date) from GET /buildinfo.
 * No auth required. Rejects on network or non-2xx response.
 */
export const getServerBuildInfo = (): Promise<BuildInfo> => {
  return getFn<BuildInfo>(BUILDINFO_URL);
};
